module.exports = __webpack_public_path__ + "img/curve_sm_2.497dad0d.svg";